module.exports = __webpack_public_path__ + "media/images/championship__iconChangeTeam-38bcf7a49ef6da64a889e309e8958a8d.png";